import { loadJsonFromUrl } from "../util/json-loader";

export interface Announcement {
  id: string;
  title: string;
  message: string;
  startDate: Date;
  endDate: Date;
  link: string | null;
  linkText: string | null;
  popup: boolean;
}

interface RawAnnouncement {
  id: string;
  title: string;
  message: string;
  startDate: string;
  endDate: string;
  link?: string;
  linkText?: string;
  popup?: boolean;
}

const ANNOUNCEMENTS_JSON_URL = "/data/announcements.json";

export async function getAnnouncements(): Promise<Announcement[] | null> {
  const announcements = await loadJsonFromUrl<RawAnnouncement[]>(
    ANNOUNCEMENTS_JSON_URL,
  );
  if (announcements === null) {
    console.error(
      `Failed to load announcements from ${ANNOUNCEMENTS_JSON_URL}. Returning null.`,
    );
    return null;
  }

  return announcements
    .filter((announcement) => isValidAnnouncement(announcement))
    .map((announcement) => parseAnnouncement(announcement));
}

// Validate announcement structure
function isValidAnnouncement(ann: any): ann is Announcement {
  return (
    ann && ann.id && ann.title && ann.message && ann.startDate && ann.endDate
  );
}

function parseAnnouncement(raw: RawAnnouncement): Announcement {
  return {
    id: raw.id,
    title: raw.title,
    message: raw.message,
    startDate: new Date(raw.startDate),
    endDate: new Date(raw.endDate),
    link: raw.link ?? null,
    linkText: raw.linkText ?? null,
    popup: raw.popup ?? false,
  };
}
